import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
    const colorValue = semanticVariables?.[`semantic_icon_${color}`];

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75ZM3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12Z"
                fill={colorValue}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75ZM8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12Z"
                fill={colorValue}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.75 12C4.75 12.4142 4.41421 12.75 4 12.75L2 12.75C1.58579 12.75 1.25 12.4142 1.25 12C1.25 11.5858 1.58579 11.25 2 11.25L4 11.25C4.41421 11.25 4.75 11.5858 4.75 12Z"
                fill={colorValue}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.75 12C22.75 12.4142 22.4142 12.75 22 12.75L20 12.75C19.5858 12.75 19.25 12.4142 19.25 12C19.25 11.5858 19.5858 11.25 20 11.25L22 11.25C22.4142 11.25 22.75 11.5858 22.75 12Z"
                fill={colorValue}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V4C12.75 4.41421 12.4142 4.75 12 4.75C11.5858 4.75 11.25 4.41421 11.25 4V2C11.25 1.58579 11.5858 1.25 12 1.25Z"
                fill={colorValue}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 19.25C12.4142 19.25 12.75 19.5858 12.75 20V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20C11.25 19.5858 11.5858 19.25 12 19.25Z"
                fill={colorValue}
            />
        </svg>
    );
};
